export default "__VITE_ASSET__BrRPdefy__"